import CustomModal from "../../../components/common/general/CustomModal/CustomModal";
import { StyleSheet } from "react-native";
import CourseGeneratorSettings from "../../../components/customCoursework/CourseGeneratorSettings/CourseGeneratorSettings";

interface CourseGeneratorSettingsModalContainerProps {
  visible: boolean;
  onClose: () => void;
  isSubmitting: boolean;
  onGenerateCourse: (numberOfModules: number, numberOfActivities: number) => void;
}

const CourseGeneratorSettingsModalContainer = ({
  visible,
  onClose,
  onGenerateCourse,
}: CourseGeneratorSettingsModalContainerProps) => {
  const handleClose = () => {
    onClose();
  };

  const handleGenerateCourse = (data) => {
    onGenerateCourse(data.numberOfModules, data.numberOfActivities);
    onClose();
  };

  return (
    <CustomModal visible={visible} onRequestClose={handleClose} showCloseButton={false} style={styles.modal}>
      <CourseGeneratorSettings onSubmit={handleGenerateCourse} onCancel={handleClose} isSubmitting={false} />
    </CustomModal>
  );
};

const styles = StyleSheet.create({
  modal: {
    margin: 10,
    maxHeight: "100%",
    width: "100%",
    maxWidth: 487,
    padding: 0,
  },
});

export default CourseGeneratorSettingsModalContainer;
